import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "environments/environment";
import {
  ModifierGroupType,
  ModifierGroupTypeUpdateDto
} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ModifierGroupTypeService {

  private requestPath = `${environment.posBaseUrl}/api/front/modifier-group-types`;

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });


  constructor(
    private http: HttpClient,
  ) { }

  public async create(menuId: string, requestDto: ModifierGroupTypeUpdateDto) : Promise<ModifierGroupType>{
    try{
      return await firstValueFrom(
        this.http.post<ModifierGroupType>(
          this.requestPath + "/" + menuId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  public async update(modifierGroupTypeId: string, requestDto: ModifierGroupTypeUpdateDto) : Promise<ModifierGroupType>{
    try{
      return await firstValueFrom(
        this.http.put<ModifierGroupType>(
          this.requestPath + "/" + modifierGroupTypeId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  public async delete(modifierGroupTypeId: string) : Promise<null>{
    try{
      return await firstValueFrom(
        this.http.delete<null>(
          this.requestPath + "/" + modifierGroupTypeId,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }
}
